<template>
  <el-dialog title="工作量业绩"  :visible.sync="cashFormVisible"  center  :close-on-click-modal="false" :append-to-body="true" custom-class="list-dialog">
    <el-col :span="24">
      <div>
        <div class="search-content">
          <el-col :span="24" class="toobar">
            <el-col :span="8">
              <el-date-picker v-model="searchdatevalue" :value-format="'yyyy-MM-dd'" style="width: 130px;" size="mini"></el-date-picker>~
              <el-date-picker v-model="searchdateend" :value-format="'yyyy-MM-dd'" style="width: 130px;" size="mini"></el-date-picker>
            </el-col>
            <el-col :span="5">
              <el-select v-model="showuguid" filterable :clearable="true" @change="setmerits" size="small" style="width: 140px">
                <el-option v-for="item in userList" :key="item.uguid"  :label="item.uname"  :value="item.uguid">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-button type="primary" icon="el-icon-search" @click="bindGrid()" size="mini">搜索</el-button>
              <el-button type="warning" v-on:click="excelPort" size="mini" v-if="(activeName=='first'||activeName=='second')&&loadexcel">导出</el-button>
            </el-col>
          </el-col>
        </div>
        <el-col :span="12">
        <el-radio-group v-model="activeName" @change="setTableHeight">
          <el-radio-button label="first">开单时分配{{percents.sale+percents.glass}}%</el-radio-button>
          <el-radio-button label="second">取镜后分配{{percents.process}}%</el-radio-button>
          <el-radio-button label="third">验光工作量</el-radio-button>
          <el-radio-button label="positivereview">好评</el-radio-button>
        </el-radio-group>
        </el-col>
        <el-col :span="12">
          （销售 {{totalmon.sale.toFixed(3)}}  、验光 {{totalmon.glass.toFixed(3)}}  、加工 {{totalmon.process.toFixed(3)}} 、共{{(totalmon.sale+totalmon.glass+totalmon.process).toFixed(3)}}）
        </el-col>
        <el-table :data="tableData.filter(o=>activeName=='first'||(activeName=='positivereview'&&(!showuguid||o.uguid==showuguid)&&o.positivereview==1))"
                  v-if="activeName=='first'||activeName=='positivereview'" :height="eltableheight" show-summary :summary-method="getSummaries" size="mini" border style="width: 100%;">
        <el-table-column  width="60"  label="序号"  align="center">
        <template slot-scope="scope">
        {{1+scope.$index}}
        </template>
        </el-table-column>
        <el-table-column label="订单号" align="left" header-align="center" width="120" prop="erpserial">
          <template slot-scope="scope">
            <div style="cursor: pointer;" @click="showDetail(scope.row)"><b>{{ scope.row.erpserial}}</b></div>
          </template>
        </el-table-column>
        <el-table-column label="单数" width="60px" align="right" header-align="center" prop="ordernum">
          <template slot-scope="scope"><span v-if="(!showuguid||scope.row.uguid==showuguid)">{{scope.row['erpserial'].indexOf('C')>-1?-1:1}}</span></template>
        </el-table-column>
        <el-table-column label="副数" width="60px" align="right" header-align="center" prop="num">
          <template slot-scope="scope"><span v-if="(!showuguid||scope.row.uguid==showuguid)">{{scope.row['num']|numeric(0)}}</span></template>
        </el-table-column>
        <el-table-column label="订单金额" width="120px" align="right" header-align="center" prop="money">
        <template slot-scope="scope">{{scope.row['money']|numeric(2)}}</template>
        </el-table-column>
        <el-table-column label="开单日期" align="left" header-align="center" min-width="160" prop="adddate">
        </el-table-column>
        <el-table-column label="开单人" align="left" header-align="center" min-width="120" prop="uname">
        </el-table-column>
        <el-table-column label="销售业绩" width="110px" align="right" header-align="center" prop="meritsorder">
        <template slot-scope="scope">{{scope.row['meritsorder']|numeric(3)}}</template>
        </el-table-column>
        <el-table-column label="验光人" align="left" header-align="center" min-width="120" prop="auditname" >
        </el-table-column>
        <el-table-column label="验光业绩" width="110px" align="right" header-align="center" prop="meritsglass">
        <template slot-scope="scope">{{scope.row['meritsglass']|numeric(3)}}</template>
        </el-table-column>
        <el-table-column label="好评" width="110px" align="center" header-align="center" prop="positivereview">
            <template slot-scope="scope">
              <b><i class="el-icon-trophy" style="color: #F56C6C;font-size: larger;cursor: pointer" @click="showGood(scope.row)" v-if="scope.row.positivereview==1&&(!showuguid||scope.row.uguid==showuguid)"></i></b>
            </template>
        </el-table-column>
          <el-table-column label="查看" align="center" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button  size="mini"  @click="showDetail(scope.row)">查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="tableDataend" v-if="activeName=='second'" :height="eltableheight" show-summary :summary-method="getSummaries" size="mini" border style="width: 100%;">
        <el-table-column  width="60"  label="序号"  align="center">
        <template slot-scope="scope">
        {{1+scope.$index}}
        </template>
        </el-table-column>
        <el-table-column label="订单号" align="left" header-align="center" min-width="120" prop="erpserial">
          <template slot-scope="scope">
            <div style="cursor: pointer;" @click="showDetail(scope.row)"><b>{{ scope.row.erpserial}}</b></div>
          </template>
        </el-table-column>
        <el-table-column label="订单金额" width="120px" align="right" header-align="center" prop="money">
        <template slot-scope="scope">{{scope.row['money']|numeric(2)}}</template>
        </el-table-column>
        <el-table-column label="开单日期" align="left" header-align="center" min-width="160" prop="adddate">
        </el-table-column>
        <el-table-column label="取镜日期" align="left" header-align="center" min-width="160" prop="nextreviewtime">
          </el-table-column>
        <el-table-column label="开单人" align="left" header-align="center" min-width="120" prop="uname">
        </el-table-column>
        <el-table-column label="销售业绩" width="110px" align="right" header-align="center" prop="meritsorder">
        <template slot-scope="scope">{{scope.row['meritsorder']|numeric(3)}}</template>
        </el-table-column>
        <el-table-column label="加工人员" align="left" header-align="center" min-width="120" prop="processuname" >
        </el-table-column>
        <el-table-column label="加工业绩" width="110px" align="right" header-align="center" prop="meritsprocess">
        <template slot-scope="scope">{{scope.row['meritsprocess']|numeric(3)}}</template>
        </el-table-column>
          <el-table-column label="查看" align="center" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button  size="mini"  @click="showDetail(scope.row)">查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="tableDataNum.filter(o=>!showuguid||o.adduguid==showuguid||o.uguid==showuguid)" v-if="activeName=='third'" :height="eltableheight" show-summary :summary-method="getSummariesNum" size="mini" border style="width: 100%;">
          <el-table-column  width="60"  label="序号"  align="center" fixed>
            <template slot-scope="scope">
              {{1+scope.$index}}
            </template>
          </el-table-column>
          <el-table-column label="顾客" align="left" header-align="center" fixed min-width="80"><template slot-scope="scope">{{scope.row['cusname']}}</template></el-table-column>
          <el-table-column label="手机号" align="left" header-align="center" fixed min-width="110"><template slot-scope="scope">{{scope.row['mobile']}}</template></el-table-column>
          <el-table-column label="日期" align="left" header-align="center" min-width="140"><template slot-scope="scope">{{scope.row['AddDate']}}</template></el-table-column>
          <el-table-column label="预检人" align="left" header-align="center" min-width="80"><template slot-scope="scope">{{scope.row['adduname']}}</template></el-table-column>
          <el-table-column label="原镜度数" align="center" header-align="center" prop="adduguid.oldmirrordegree" >
            <template slot-scope="scope"><i class="el-icon-check" style="color: #409EFF;font-size: larger" v-if="showCheck(scope.row.oldmirrordegree,scope.row.adduguid)"></i></template>
          </el-table-column>
          <el-table-column label="生物测量" align="center" header-align="center" prop="adduguid.biometric" >
            <template slot-scope="scope"><i class="el-icon-check" style="color: #409EFF;font-size: larger" v-if="showCheck(scope.row.biometric,scope.row.adduguid)"></i></template>
          </el-table-column>
          <el-table-column label="眼底照相" align="center" header-align="center" prop="adduguid.funduscamera" >
            <template slot-scope="scope"><i class="el-icon-check" style="color: #409EFF;font-size: larger" v-if="showCheck(scope.row.funduscamera,scope.row.adduguid)"></i></template>
          </el-table-column>
          <el-table-column label="裂隙灯" align="center" header-align="center" prop="adduguid.slitlamp" >
            <template slot-scope="scope"><i class="el-icon-check" style="color: #409EFF;font-size: larger" v-if="showCheck(scope.row.slitlamp,scope.row.adduguid)"></i></template>
          </el-table-column>
          <el-table-column label="电脑验光" align="center" header-align="center" prop="adduguid.computeroptometry" >
            <template slot-scope="scope"><i class="el-icon-check" style="color: #409EFF;font-size: larger" v-if="showCheck(scope.row.computeroptometry,scope.row.adduguid)"></i></template>
          </el-table-column>
          <el-table-column label="验光人" align="left" header-align="center" min-width="80"><template slot-scope="scope">{{scope.row['uname']}}</template></el-table-column>
          <el-table-column label="验光" align="center" header-align="center" prop="uguid.hasglasses" >
            <template slot-scope="scope"><i class="el-icon-check" style="color: #409EFF;font-size: larger" v-if="showCheck(scope.row.hasglasses,scope.row.uguid)"></i></template>
          </el-table-column>
          <el-table-column label="原镜视力" align="center" header-align="center" prop="uguid.jjjzsl" >
            <template slot-scope="scope"><i class="el-icon-check" style="color: #409EFF;font-size: larger" v-if="showCheck(scope.row.jjjzsl,scope.row.uguid)"></i></template>
          </el-table-column>
          <el-table-column label="裸眼视力" align="center" header-align="center" prop="uguid.lysl" >
            <template slot-scope="scope"><i class="el-icon-check" style="color: #409EFF;font-size: larger" v-if="showCheck(scope.row.lysl,scope.row.uguid)"></i></template>
          </el-table-column>
          <el-table-column label="主视眼" align="center" header-align="center" prop="uguid.zsy" >
            <template slot-scope="scope"><i class="el-icon-check" style="color: #409EFF;font-size: larger" v-if="showCheck(scope.row.zsy,scope.row.uguid)"></i></template>
          </el-table-column>
          <el-table-column label="worth4点" align="center" header-align="center" prop="uguid.worth" >
            <template slot-scope="scope"><i class="el-icon-check" style="color: #409EFF;font-size: larger" v-if="showCheck(scope.row.worth,scope.row.uguid)"></i></template>
          </el-table-column>
          <el-table-column label="立体视" align="center" header-align="center" prop="uguid.lts" >
            <template slot-scope="scope"><i class="el-icon-check" style="color: #409EFF;font-size: larger" v-if="showCheck(scope.row.lts,scope.row.uguid)"></i></template>
          </el-table-column>
          <el-table-column label="眼位" align="center" header-align="center" prop="uguid.yw" >
            <template slot-scope="scope"><i class="el-icon-check" style="color: #409EFF;font-size: larger" v-if="showCheck(scope.row.yw,scope.row.uguid)"></i></template>
          </el-table-column>
          <el-table-column label="瞳高" align="center" header-align="center" prop="uguid.tg" >
            <template slot-scope="scope"><i class="el-icon-check" style="color: #409EFF;font-size: larger" v-if="showCheck(scope.row.tg,scope.row.uguid)"></i></template>
          </el-table-column>
          <el-table-column label="查看" align="center" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"  v-if="scope.row.hasglasses"
                @click="viewReport(scope.row)">查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-col>
    <showGlassessell ref="showGlassessell1"></showGlassessell>
    <fileimgview ref="fileimgview1"></fileimgview>
  </el-dialog>
</template>
<script>

  import { workloaddetail,workloadGlasses} from '@/api/set/csagreement';
  import showGlassessell from '@/components/testorder/cstagreement/showGlassessell';
  import fileimgview from '@/components/common/Fileimgview';

  export default {
    name: 'Workloaddetail',
    data() {
      return {
        activeName:'first',
        allData:[],
        loadexcel:false,
        tableData: [],
        tableDataend:[],
        tableDataNum:[],
        userList:[],
        showuguid:'',
        cashFormVisible:false,
        formLabelWidth: '70px',
        eltableheight:'300',
        searchdatevalue: '',//年份
        searchdateend: '',
        percents:{sale:0,glass:0,process:0},
        totalmon:{sale:0,glass:0,process:0},
      }
    },
    methods: {
      showCheck(num,uguid){
        if(num>0){
          return (!this.showuguid||uguid==this.showuguid);
        }
        return false;
      },
      showGood(item) {
        this.$refs.fileimgview1.bindData(item.unitguid, 'positivereview');
      },
      setTableHeight() {
        var th = this.dialogtableHeight(this.$route.query.bimanage ? 150 : 150);
        this.eltableheight = this.eltableheight == th ? (th - 1) : th;
      },
      showDetail(row) {
        this.$refs.showGlassessell1.show({groupguid: row.unitguid,showyg:row.showyg});
      },
      initData(searchdatevalue, searchdateend, row, users) {
        this.activeName = 'first';
        this.searchdatevalue = searchdatevalue;
        this.searchdateend = searchdateend;
        this.showuguid = row.uguid;
        this.userList = users;
        this.cashFormVisible = true;
        this.bindGrid();
      },
      viewReport(item) {
        var row = this.allData.find(o => o.glassesguid == item.glassesguid && !o.erpserial.startsWith('C'));
        if (!row) return;
        this.showDetail({unitguid:row.unitguid,showyg:1});
      },
      checkDateSepar() {
        if (!this.searchdatevalue || !this.searchdateend) {
          this.$message({
            message: '日期范围必须选择！',
            type: 'error'
          })
          return false;
        }

        var startDate = new Date(this.searchdatevalue);
        var endDate = new Date(this.searchdateend);
        var preDate = new Date(endDate.getTime() - 92 * 24 * 60 * 60 * 1000);
        var errerMSG = "只能查询三个月范围内的数据！";
        if (startDate <= preDate) {
          this.$message({
            message: errerMSG,
            type: 'error'
          })
          return false;
        } else {
          return true;
        }
      },
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        var control=this;
        columns.forEach((column, index) => {
          if (index === 0)
            return;
          if (index === 1) {
            sums[index] = '合计';
            return;
          }
          if (!column.property) return;
          if(column.property=='ordernum'){
            var totalNum=0;
            for(let i in data) {
              if(!control.showuguid || data[i].uguid == control.showuguid){
                totalNum += data[i].erpserial.indexOf('C') > -1 ? -1 : 1;
              }
            }
            sums[index] = totalNum;
            return;
          }else if(column.property=='num'||column.property=='positivereview') {
            var totalNum=0;
            for(let i in data) {
              if(!control.showuguid || data[i].uguid == control.showuguid){
                totalNum += data[i][column.property];
              }
            }
            sums[index] = totalNum;
            return;
          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            if (column.property.indexOf('money') > -1) {
              sums[index] = sums[index] ? parseFloat(sums[index]).toFixed(2) : 'N/A';
            } else if (column.property.indexOf('merits') > -1) {
              sums[index] = sums[index] ? parseFloat(sums[index]).toFixed(3) : 'N/A';
            } else if(column.property=='positivereview'){
              sums[index] = sums[index] ? parseFloat(sums[index]).toFixed(0) : '';
            } else {
              sums[index] = '';
            }
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
      getSummariesNum(param) {
        const {columns, data} = param;
        const sums = [];
        const selUguid=this.showuguid;
        columns.forEach((column, index) => {
          if (index === 0)
            return;
          if (index === 1) {
            sums[index] = '合计';
            return;
          }
          if (!column.property) return;
          var uguidColumn=column.property.split('.')[0];
          var ygColumn=column.property.split('.')[1];
          const values = data.map(item =>
            Number((!selUguid||selUguid==item[uguidColumn])?item[ygColumn]:0)
          );
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = sums[index] ? parseFloat(sums[index]).toFixed(0) : 'N/A';
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
      emptyItem(uguid, uname) {
        return {
          uguid: uguid,
          uname: uname,
          oldmirrordegree: 0,
          biometric: 0,
          funduscamera: 0,
          slitlamp: 0,
          computeroptometry: 0,
          intraocularpressure: 0,
          glass: 0,
          glassno: 0,
          order: 0,
          ordermoney: parseFloat(0.00),
          realnum: 0,
          realmoney: parseFloat(0.00),
          backover: 0,
          backovermoney: parseFloat(0.00),
          meritsorder: parseFloat(0.00),//订单绩效金额
          meritsglass: parseFloat(0.00),//验光绩效金额
          meritsprocess: parseFloat(0.00),//加工绩效金额
          meritstotal: parseFloat(0.00),//绩效合计
          process: 0,
          quality: 0,
          over: 0,
          total: 0
        };
      },
      bindGrid() {//绑定列表
        if (!this.checkDateSepar()) {
          return;
        }
        this.tableDataNum = [];
        var startDate = new Date(this.searchdatevalue);
        var endDate = new Date(this.searchdateend);
        var searchP = {
          begindate: startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getDate(),
          enddate: endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + '-' + endDate.getDate() + ' 23:59:59',
        };
        workloaddetail(searchP).then(response => {
          this.percents = response.data.set;
          this.allData = response.data.obj;
          this.setmerits();
          var th = this.dialogtableHeight(this.$route.query.bimanage ? 150 : 150);
          this.eltableheight = this.eltableheight == th ? (th - 1) : th;

          workloadGlasses(searchP).then(
            resGlass => {
              this.tableDataNum = resGlass.data.obj;
              for (let i in this.tableDataNum) {
                if (this.tableDataNum[i].glassesguid) {
                  this.tableDataNum[i].hasglasses = 1;
                }
              }
            }
          )
        }).catch((error) => {
          console.log(error)
        });
      },
      setmerits() {
        this.tableData = [];
        this.tableDataend = [];
        this.totalmon = {sale: 0, glass: 0, process: 0};

        for (let i in this.allData) {
          var row = this.allData[i];
          row['meritsprocess'] = null;
          row['meritsorder'] = null;
          row['meritsglass'] = null;

          var itemMoney = parseFloat(row.money);

          if (row.componentpath == 'processorder' || row.componentpath == 'processorderbackover') {
            var processM = itemMoney * parseFloat(this.percents.process * 0.01);
            if (row.processuguid) {
              if (!this.showuguid || this.showuguid == row.processuguid) {
                row['meritsprocess'] = processM;
                this.totalmon.process += processM;
                this.tableDataend.push(row);
              }
            } else {
              if (!this.showuguid || this.showuguid == row.uguid) {
                row['meritsorder'] = processM;
                this.totalmon.sale += processM;
                this.tableDataend.push(row);
              }
            }
          } else {
            var hadValue = false;
            var salepercents = parseFloat(this.percents.sale);
            if (row.auditguid) {
              if (!this.showuguid || this.showuguid == row.auditguid) {
                hadValue = true;
                var glassM = itemMoney * parseFloat(this.percents.glass) * 0.01;
                row['meritsglass'] = glassM;
                this.totalmon.glass += glassM;
              }
            } else {//没验光单，比例计算给配镜顾问
              salepercents += parseFloat(this.percents.glass);
            }
            if (!this.showuguid || this.showuguid == row.uguid) {
              hadValue = true;
              var orderM = itemMoney * parseFloat(salepercents * 0.01);
              row['meritsorder'] = orderM;
              this.totalmon.sale += orderM;
            }
            if (hadValue)
              this.tableData.push(row);
          }
        }
      },
      excelPort() {
        let data = []
        let header1 = '';
        let column1 = '';
        var pre = '';
        if (this.activeName == 'first') {
          pre = '开单业绩'
          for (let i in this.tableData) {
            data.push(Object.assign({}, this.tableData[i]))
          }
          header1 = ["订单号", "订单金额", "开单日期", "开单人", "销售业绩", "验光人", "验光业绩"]
          column1 = ["erpserial", "money", "adddate", "uname", "meritsorder", "auditname", "meritsglass"]
        } else if (this.activeName == 'second') {
          pre = '加工业绩'
          for (let i in this.tableDataend) {
            data.push(Object.assign({}, this.tableDataend[i]))
          }
          header1 = ["订单号", "订单金额", "开单日期", "取镜日期", "开单人", "销售业绩", "加工人员", "加工业绩"]
          column1 = ["erpserial", "money", "adddate", "nextreviewtime", "uname", "meritsorder", "processuname", "meritsprocess"]
        }

        var startDate = new Date(this.searchdatevalue);
        var endDate = new Date(this.searchdateend);

        var name = pre + (startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getDate()) + '至' + (endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + '-' + endDate.getDate());

        this.$exportExcel(header1, column1, data, name)
      }
    },
    mounted() {
      this.searchdateend = new Date();//当天
      this.searchdatevalue = new Date(this.searchdateend .getFullYear(), this.searchdateend .getMonth(), 1);
      if (!this.$route.query.bimanage) {
        this.loadexcel = true;
      } else {
        this.loadexcel = this.$route.query.excel ? true : false;
      }
    },
    components: {showGlassessell,fileimgview}
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/Workloaddetail.vue